import { CateringProvider } from '../app/CateringProvider';
import type { CateringService } from '../services/cateringService';
import { OrderDraftProvider } from '../state/OrderDraftProvider';
import { isCateringOrderAllowed } from '../utils/meetingEligibility';
import type { MeetingInfo } from '../types/meeting';
import UnavailablePage from './UnavailablePage';
import { ORDER_PATHS, Router } from '../router';
import SetupDetailsPage from './SetupDetailsPage';
import MenuPage from './MenuPage';
import ProductDetailPage from './ProductDetailPage';
import OrderReviewPage from './OrderReviewPage';
import OrderConfirmationPage from './OrderConfirmationPage';

export type OrderFlowProps = {
  meeting: MeetingInfo;
  cateringService: CateringService;
};

export default function OrderFlow({ meeting, cateringService }: OrderFlowProps) {
  if (!meeting.isOrganizer) {
    return <UnavailablePage message="Only the meeting organizer can place a catering order." />;
  }

  if (!isCateringOrderAllowed(meeting)) {
    return <UnavailablePage message="Catering orders are available for future meetings only." />;
  }

  return (
    <CateringProvider service={cateringService}>
      <OrderDraftProvider>
        <Router
          routes={[
            { path: ORDER_PATHS.setup, element: <SetupDetailsPage meeting={meeting} /> },
            { path: ORDER_PATHS.menu, element: <MenuPage /> },
            { path: ORDER_PATHS.product, element: <ProductDetailPage /> },
            { path: ORDER_PATHS.review, element: <OrderReviewPage /> },
            {
              path: ORDER_PATHS.confirmation,
              element: <OrderConfirmationPage meetingTitle={meeting.subject} />,
            },
          ]}
          fallback={<UnavailablePage message="This catering step could not be found." />}
        />
      </OrderDraftProvider>
    </CateringProvider>
  );
}
